/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateCardProductionCommand = {
    maxCardCount: number;
    /**
     * Define production type. Supertype of "cardProductionCardType". "PERSONAL" or "NOT_PERSONAL"
     */
    cardProductionType: CreateCardProductionCommand.cardProductionType;
    /**
     * Define card types in production. "PERSONAL", "EXPRESS", "RECLAMATION", ect
     */
    cardProductionCardType: CreateCardProductionCommand.cardProductionCardType;
    lastCardNumber?: string;
    /**
     * For not personal cards valid to date. Type: 'DATE'
     */
    cardValidTo?: string;
    branchOfficeId?: string;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace CreateCardProductionCommand {
    /**
     * Define production type. Supertype of "cardProductionCardType". "PERSONAL" or "NOT_PERSONAL"
     */
    export enum cardProductionType {
        PERSONAL = 'PERSONAL',
        NOT_PERSONAL = 'NOT_PERSONAL',
    }
    /**
     * Define card types in production. "PERSONAL", "EXPRESS", "RECLAMATION", ect
     */
    export enum cardProductionCardType {
        PERSONAL = 'PERSONAL',
        EXPRESS = 'EXPRESS',
        PORTABLE = 'PORTABLE',
        RECLAMATION = 'RECLAMATION',
        EMPLOYEE = 'EMPLOYEE',
    }
}

